import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription, timer } from 'rxjs';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
@Injectable({
  providedIn: 'root'
})
export class DatastoreService {
  public daySelected = new Subject<any>();

  constructor() { }

  setCalendarDay(date: any, slot: any): any {
    return slot.daySelected.next(date);
  }

  getCalendarDay(slot: any): Observable<any> {
    return slot.daySelected.asObservable();
  }

  getLatestMulti(): any {
    if (this.extraBookings.length === 0) {
      this.newMultiBooking()
    }
    return this.extraBookings[this.extraBookings.length - 1]
  }

  newMultiBooking() {
    this.extraBookings.push({
      bookingDetails: {
        serviceId: "",
        childCompanyId: "",
        parentCompanyId: "",
        resourceId: "",
        resourceName: "",
        event_id: "",
        time: "",
        date: "",
        addon: "",
        attendees: [],
        bookingId: "",
        res: ""
      },
      daySelected: new Subject<any>(),
      bookingQuestions: []
    })
  }

  public multi = false

  public config: any;

  public companies: any;

  public childCompanies: any;

  public isDayService: any;

  public selectedDate: any;

  public services: any;

  public resources = [];

  public slots = [];

  public extraBookings: any = []; // added via sidebar

  public rootCompany: any;

  public selectedCompany: any;

  public selectedService: any;

  public selectedResource: any;

  public selectedSlot: any;

  public selectedResourceLabel: String = "";

  public bookingQuestions = [];

  public customerQuestions = [];

  public address: any;

  public lattitude: any;

  public longitude: any;

  public bookings: any;

  public tabBookingsCounts: any;

  public limits: any;

  public purchase: any;

  public client: any;

  public loginObject: any;

  public loggedIn: boolean = false;

  public selectedServiceName: any;

  public members: any;

  public member: any;

  public company: any;

  public childCompany: any;

  public authToken: any;

  public timeLimits: any;

  public basket: any;

  public basketEndTime: any;

  public serviceItem: any;

  public checkout: any = "";

  public answeredQuestions: any;

  public loggedInBySSO: boolean = false;

  public paidAmount: number = 0;

  public purchasedBookings: any = [];

  public newrelic?: BrowserAgent;

  public refreshTimer = 0;

  public refresher: any = null;

  public version: any = 0.0;

  tabNoBookingCount: number = 0;

  public loadedApplication: any = false;

  public childrenToRegister: any[] = [];

  public booking: any

  public primary_btn_text_colour: string = "white"
  public primary_btn_back_colour: string = "#00703c"
  public primary_btn_back_colour_hover: string = "#005a30"
  public primary_btn_text_colour_hover: string = "white"

  public secondary_btn_text_colour: string = "black"
  public secondary_btn_back_colour: string = "#f3f2f1"
  public secondary_btn_back_colour_hover: string = "#dbdad9"
  public secondary_btn_text_colour_hover: string = "black"

  // changes need to be made on access page instance too
  public bookingDetails: any = {
    serviceId: "",
    childCompanyId: "",
    parentCompanyId: "",
    resourceId: "",
    resourceName: "",
    event_id: "",
    duration: "",
    time: "",
    date: "",
    addon: "",
    find: "",
    duartion: "",
    res: "",
    bookingId: ""
  }

  timer = false;

  lastPage = "/services"
}
